<app-last-sales-table [sales]="sales$ | async" (saleDetailsClick)="handleSaleDetailsClick($event)" />

@if (loading) {
  <app-loading />
}
